/* eslint no-template-curly-in-string: 0 */

import { cloneDeep } from 'lodash';
import {translate} from 'shared/services/I18nService';
const $t = translate.scope('dst');

(function ($) {
  var constants = {
    various: '[various]',
    popupLabelCssClass: 'dst-label-popup',
    rotationClassPrefix: 'us_rotate'
  };

  var displayedSlides;
  var CurrentVm;
  var ViewModels = {};
  var CaseSelectedSlides = {}; // Used to preserve selected slides when loading cases
  var prevSelectedSlide = null; // used to preserve last selected slide when moving between prior cases
  var renderMode = '';
  var dstSettings = {};

  $.fn.dst = function (vil) {
    var self = this;

    if (vil == null || typeof vil === 'undefined') {
      $.error('Vil instance cannot be null');
    }

    //
    // DST events
    //
    var dstEventSlideChangeStopped = 'dst_evSLIDECHANGESTOPPED';

    /*************************************************************************************************************
         PRIVATE FUNCTIONS -- this are the functions which are available internally
         *************************************************************************************************************/

    var getActiveViewModel = function () {
      // For efficiency
      if ($('#' + CurrentVm.divId + ':visible').length) {
        return CurrentVm;
      }

      var result = null;
      $.each(ViewModels, function (divId, vm) {
        if ($('#' + divId + ':visible').length) {
          result = vm;
          return false;
        }
      });

      if (result == null) {
        // dependendent observables being called before DST is visible
        return CurrentVm;
      }

      return result;
    };

    /*************************************************************************************************************
         START RENDER
         *************************************************************************************************************/
    /**
         *
         * @param {object} dstInfo
         * @param {object} dstSettings
         * @param {boolean} isPrimaryCase
         * @returns {unresolved}
         */
    var render = function (dstInfo, dstSettings, isPrimaryCase) {
      // Only one vm per div. Since we are recreating the vm, delete the prior
      if (ViewModels[dstSettings.divId] != null) {
        delete ViewModels[dstSettings.divId];
      }

      self.each(function () {
        // ctor
        var vm =
                        {
                          allSlides: [],
                          posNegSlides: ko.observableArray(),
                          selectedSlide: null,
                          numSlides: 0,
                          slideCount: {},
                          currentView: 'tray',
                          dstId: dstInfo.dstId,
                          divId: dstSettings.divId,
                          tableName: dstInfo.tableName,
                          cases: [],
                          activeCase: ko.observable(),
                          displayTrayIdx: ko.observable(),
                          displayTray: ko.observable(),
                          currentCase: ko.observable(),
                          deletedSlides: [],
                          memoSlides: ko.observableArray(),
                          waitForCompletion: 0,
                          trayIsModified: false,
                          labelRotation: 0,
                          cantChangeSlide: false,
                          cantToggleSlide: false, // set to true to prevent user for toggleing selected slide (for example
                          summarySlidesOnly: false, // if true, only display slide info in summary title
                          isBusy: ko.observable(false),
                          _dummyObservableForPinnedCountUpdate: ko.observable(),
                          _dummyObservableForSettingsUpdate: ko.observable(),
                          addCaseBehaviors: function (elements) {
                            if (dstSettings.enableMultiTray) {
                              dstEditTray(dstSettings);
                            }

                            if (dstSettings.enableEnhancedView) {
                              addHoverBehavior(dstSettings);
                            }
                          },
                          addSlideBehaviors: function () {
                            if (dstSettings.enableEnhancedView) {
                              addHoverBehavior(dstSettings);
                            }
                          },

                          // Multitray display
                          showSlideTrayEditor: function () {
                            var doInit = function () {
                              var vm = getActiveViewModel();

                              $('#dst_EditTrays').dialog({
                                autoOpen: true,
                                modal: true,
                                width: 'auto',
                                closeOnEscape: true,
                                title: $t('organize-slide-trays') + vm.activeCase().title,
                                position: { my: 'center', at: 'center', of: window },
                                closeText: $t('close'),
                                resizable: true,
                                create: function () {
                                  var vm = getActiveViewModel();
                                  var editTraysVm = vm.activeCase().editTraysVm;
                                  dstEditTray(vm.settings);
                                  // apply bindings once here when we open the edit trays popup
                                  ko.applyBindings(vm, $('#dst_EditTrays').get()[0]);

                                  var startTrayIdx = vm.displayTray().index;
                                  var endTrayIdx = startTrayIdx + vm.settings.traysPerMulti;
                                  if (endTrayIdx >= vm.numTrays) {
                                    endTrayIdx = vm.numTrays;
                                    startTrayIdx = endTrayIdx - vm.settings.traysPerMulti;
                                    if (startTrayIdx < 0) {
                                      startTrayIdx = 0;
                                    }
                                  }
                                  editTraysVm.startTrayIndex(startTrayIdx); // this will also apply ko bindings
                                  editTraysVm.startTrayIndex.valueHasMutated(); // since init value is also zero, tell subscribers the value changed (enables the next button)
                                  editTraysVm.endTrayIndex(endTrayIdx);

                                  vm.currentView = 'multi';
                                },
                                open: function () {
                                  var $this = $(this);
                                  self.putSlidesIntoMulti(vm)
                                    .then(function () {
                                      var dialog = $this.dialog({
                                        position: { my: 'center', at: 'center', of: window }
                                      });
                                      var parent = dialog.parent();
                                      var zIndex = parent.css('z-index');
                                      parent.css('z-index', zIndex * 10);
                                    });
                                },
                                beforeClose: function () {
                                  // need to remove bindings here, not on onClosed, because the #dst_EditTrays div has already been removed
                                  // by the time close() is called
                                  ko.cleanNode($('#dst_EditTrays').get()[0]); // remove bindings so we can reapply next time we open
                                },
                                close: function () {
                                  vm.activeCase().editTraysVm.cleanup();

                                  vm.currentView = 'tray';
                                  // update display tray with any changes
                                  vm.putSlidesIntoDisplayTray(vm);
                                }
                              });
                            };

                            $('.dst_container').delegate('.dst_multiTrayLink', 'click', function (event) {
                              $('.dst_container').undelegate('.dst_multiTrayLink', 'click');

                              doInit();

                              event.preventDefault();
                            });
                          },
                          moveNextSlide: function () {
                            var vm = getActiveViewModel();
                            var slides = vm.getSlides(vm);

                            var lastSlide = vm.getSelectedSlide(vm);
                            if (lastSlide) {
                              var slideIdx = lastSlide.positionIndex;
                              while (true) {
                                slideIdx++;
                                if (slideIdx == slides.length) {
                                  return;
                                }
                                if (slides[slideIdx].isMultiSlideSelected()) {
                                  continue;
                                }
                                // if we click on next slide we don't want to open the slide which is already send for multiSlide
                                if (slides[slideIdx].isBlank == false) {
                                  break;
                                }
                              }

                              vm.setSelectedSlide(vm, slides[slideIdx], lastSlide);
                            } else {
                              vm.selectSlide(vm);
                            }
                          },
                          movePrevSlide: function () {
                            var vm = getActiveViewModel();
                            var slides = vm.getSlides(vm);

                            var lastSlide = vm.getSelectedSlide(vm);
                            if (lastSlide) {
                              var slideIdx = lastSlide.positionIndex;
                              while (true) {
                                slideIdx--;
                                if (slideIdx < 0) {
                                  return;
                                }
                                // if we click on next slide we don't want to open the slide which is already send for multiSlide
                                if (slides[slideIdx].isMultiSlideSelected()) {
                                  continue;
                                }
                                if (slides[slideIdx].isBlank == false) {
                                  break;
                                }
                              }

                              vm.setSelectedSlide(vm, slides[slideIdx], lastSlide);
                            } else {
                              vm.selectSlide(vm);
                            }
                          },
                          // this is the function which is used to return the slideWithin the posNegSlide
                          getPosNegSlide: function (sampleType) {
                            if (vm.posNegSlides().length > 0) {
                              var returnSlide = null;
                              $.each(vm.posNegSlides(), function (item) {
                                // checking if the imageId matches the one in posNegControl
                                if (this.sampleType == sampleType) {
                                  //  we need to put back the posNeg slide in the DST
                                  returnSlide = this;
                                  return false;
                                }
                              });

                              return returnSlide;
                            }

                            return null;
                          },
                          // this is the function which is used to invoke on a callback from the uScope
                          // it closed image from +/- control slides and re-insert them in the DST
                          // it de-selects image if it is the current image.
                          //
                          closeSlide: function (encodedImageId) {
                            //                      var start = new Date().getMilliseconds();

                            var vm = getActiveViewModel();

                            if (dstSettings.displayPosNegControl && !dstSettings.displayMultiSlide) {
                              // we have posNegSlides
                              if (vm.posNegSlides().length > 0) {
                                var closingSlide = null;

                                var mergedArray = [];
                                $.merge(mergedArray, vm.posNegSlides());
                                $.merge(mergedArray, vm.getSlides(vm));

                                $.each(mergedArray, function (item) {
                                  // checking if the imageId matches the one in posNegControl
                                  if (this.encodedImageId == encodedImageId) {
                                    // we need to put back the posNeg slide in the DST
                                    closingSlide = this;
                                    // added call which forces uScope to close the image
                                    vil.uScopeImageUpdate('remove', {'image': this});
                                    return false;
                                  }
                                });

                                if (closingSlide != null) {
                                  var index = vm.posNegSlides.indexOf(closingSlide);
                                  if (index > -1) {
                                    //  this is a PosNeg control slide
                                    var lastIdx = vm.allSlides.length - 1;
                                    var toPos = closingSlide.positionIndex;
                                    closingSlide.sampleType = 'patient';
                                    closingSlide.isValidSlide = true;
                                    closingSlide.isPinned = false;

                                    // adding to the slides
                                    vm.posNegSlides.splice(index, 1);

                                    vm.allSlides.splice(closingSlide.positionIndex, 0, closingSlide);

                                    $(this).reorderSlides(vm, lastIdx, toPos);
                                  } else {
                                    // this is a patient slide.

                                    // we need to select the next slide if we are closing the currently selected slide.
                                    var lastSlide = vm.getSelectedSlide(vm);
                                    if (lastSlide.encodedImageId == encodedImageId) {
                                      lastSlide.isSelected(false);

                                      vm.selectedSlide = null;

                                      // Clear all secondarys, then set this
                                      vm.clearSecondarySelections(vm);
                                    }
                                  }
                                }
                              }
                            } else if (dstSettings.displayMultiSlide && !dstSettings.displayPosNegControl) {
                              closingSlide = null;
                              // find the slide the user indicated should be closed
                              $.each(vm.getSlides(vm), function (item) {
                                if (this.encodedImageId == encodedImageId) {
                                  closingSlide = this;
                                  return false;
                                }
                              });

                              if (closingSlide != null) {
                                if (closingSlide.isPinned) {
                                  closingSlide.isMultiSlideSelected(false); // Thi will mark slide as unpinned, and tells uScope to close the slide image
                                } else {
                                  // if the user is trying to close the unpinned image, then get one of the pinned images,
                                  // close it, then replace unpinned image with the pinned image just closed
                                  var pinnedSlides = $.grep(vm.getSlides(vm), function (s) {
                                    return s.isPinned;
                                  });
                                  if (pinnedSlides.length > 0) {
                                    var nextSlide = pinnedSlides[0];
                                    nextSlide.isMultiSlideSelected(false); // Marks as pinned and tells uScope to open the slide image
                                    vm.setSelectedSlide(vm, nextSlide, closingSlide); // Replace the unpinned image with the just closed pinned slide
                                  }
                                }
                              }
                            }
                          },
                          createContextMenu: function (vm) {
                            vm.contextMenuText = [];
                            vm.contextMenuText[0] = $t('insert-blank-slot');
                            if (vm.settings.allowDeleteSlides) {
                              vm.contextMenuText[1] = $t('delete-selected-slides');
                            } else if (vm.settings.allowRemoveSlides) {
                              vm.contextMenuText[1] = $t('remove-selected-slides');
                            } else {
                              vm.contextMenuText[1] = $t('remove-selected-blanks');
                            }
                            vm.contextMenuText[2] = $t('toggle-read');
                          },
                          // Right click on a slide
                          // Display the contextMenu
                          onMenuShow: function (event, context) {
                            var vm = getActiveViewModel();
                            if (vm.settings.allowContextMenu == false) {
                              return false;
                            }

                            var slide = getContextSlide(event, context);
                            if (slide.isValidSlide == false) {
                              return false;
                            }
                            if (!event.ctrlKey) {
                              if (!slide.isSecondarySelected()) {
                                // Deselect all other slides only if click on an unselected slide
                                vm.clearSecondarySelections(vm);
                              }
                            }
                            slide.isSecondarySelected(true);

                            var slides = vm.getSecondarySlides();
                            if (slides.length == 0) {
                              return false; // no slide selected
                            }

                            var hasValidSlide = false;
                            var hasBlankSlide = false;
                            $.each(slides, function () {
                              if (this.isBlank) {
                                hasBlankSlide = true;
                              } else {
                                hasValidSlide = true;
                              }
                            });

                            var ul = $('#dst_SlideContextMenu_' + dstSettings.uniqueId)[0];
                            var contextMenu = ul.children;

                            // Add Blank Slides
                            if (slides.length < 2) {
                              contextMenu[0].style.display = '';
                            } else {
                              contextMenu[0].style.display = 'none';
                            }

                            // Remove Slides / Remove Blank Slides
                            if (vm.settings.allowRemoveSlides || hasBlankSlide) {
                              contextMenu[1].style.display = '';
                            } else {
                              contextMenu[1].style.display = 'none';
                            }

                            // Toggle read/unread
                            if (vm.settings.allowToggleRead && hasValidSlide) {
                              contextMenu[2].style.display = '';
                            } else {
                              contextMenu[2].style.display = 'none';
                            }
                          },
                          onMenuHide: function (event, context) {
                          },
                          onMenuSelect: function (event, context) {
                            var vm = getActiveViewModel();
                            var $target = $(context);
                            // var   id = $target.closest(".dst_container").data("itemId"), groupTitle;
                            var isMultiTray = (vm.currentView === 'multi');

                            if ($(this).hasClass('disabled')) {
                              return false;
                            }

                            switch ($(this).text()) {
                              case `${$t('insert-blank-slot')}`:
                                var insertTrayIndex;
                                if (isMultiTray) {
                                  insertTrayIndex = $target.closest('.dst_tray').parent().index() + vm.activeCase().editTraysVm.startTrayIndex();
                                } else {
                                  insertTrayIndex = vm.displayTray().index;
                                }
                                var insertTrayPos = $target.parent().index() +
                                                (vm.settings.slidesPerColumn * ($target.closest('ul').hasClass('dst_slide-col-1') ? 0 : 1));
                                var insertPos = (insertTrayIndex * vm.settings.slidesPerTray) + insertTrayPos;

                                var slides = vm.getSlides(vm);
                                var group = slides[insertPos].group;

                                insertBlankSlide(vm, insertPos, group, isMultiTray);

                                break;

                              case vm.contextMenuText[1]:
                                // Delete/Remove Slides/Blanks
                                var ans = confirm($t('remove-slides-confirm'));
                                if (ans == false) {
                                  break;
                                }

                                var selectedSlides = vm.getSecondarySlides();
                                var lastSlideIdx = vm.allSlides.length - 1;
                                for (var idx = 0; idx < selectedSlides.length; idx++) {
                                  var slide = selectedSlides[idx];

                                  if ((vm.settings.allowRemoveSlides == false) && (slide.isBlank == false)) {
                                    // Can only remove blank slides
                                    continue;
                                  }

                                  var slideIdx = slide.positionIndex;

                                  // Replace slide with an invalid slide & then move to end of list
                                  var blankSlide = vm.createBlank(vm, slideIdx);
                                  self.putSlide(vm, blankSlide, slideIdx);

                                  self.reorderSlides(vm, slideIdx, lastSlideIdx);

                                  vm.deletedSlides.push(slide);
                                }

                                // The deleted slide may have been the selected slide
                                vm.selectSlide(vm);

                                break;

                              case `${$t('toggle-read')}`:
                                vm.toggleReadSelectedSlides(vm);
                                break;
                              default:
                            }

                            vm.clearSecondarySelections(vm);
                          },
                          onSlidesRendered: function () {
                            //
                          },
                          priorCase: ko.observable(),
                          relatedCaseId: ko.observable(),
                          relatedCases: null,
                          settings: dstSettings,
                          toggleReadSelectedSlides: function (vm) {
                            $.each(vm.getSecondarySlides(), function () {
                              this.isRead(!this.isRead());
                            });
                          },
                          getSlides: function (vm) {
                            return vm.allSlides;
                          },
                          getDeletedSlides: function (vm) {
                            return vm.deletedSlides;
                          },
                          getSlide: function (vm, positionIdx) {
                            return vm.allSlides[positionIdx];
                          },
                          getVisibleSlides: function (vm) {
                            if (vm.currentView === 'tray') {
                              return vm.displayTray().slides();
                            }

                            // multi
                            var slides = [];
                            $.each(vm.activeCase().editTraysVm.trays(), function () {
                              $.each(this.slides(), function () {
                                slides.push(this);
                              });
                            });
                            return slides;
                          },
                          getVisibleSlide: function (vm, col, position, iTray) {
                            var idx;
                            if (vm.currentView === 'tray') {
                              idx = (col * vm.settings.slidesPerColumn) + position;
                            } else {
                              idx = (iTray * vm.settings.slidesPerTray) + (col * vm.settings.slidesPerColumn) + position;
                            }
                            var slides = vm.getVisibleSlides(vm);
                            return slides[idx];
                          },
                          // Return all secondary selected slides
                          getSecondarySlides: function () {
                            var vm = getActiveViewModel();
                            var selectedSlides = [];
                            var slides = vm.getSlides(vm);
                            $.each(slides, function () {
                              if (this.isSecondarySelected()) {
                                selectedSlides.push(this);
                              }
                            });
                            return selectedSlides;
                          },
                          // Return all slides we think the user intended to act upon
                          getChosenSlides: function (vm, slide) {
                            var returnSecondaries = false;
                            var secondarySlides = vm.getSecondarySlides();
                            $.each(secondarySlides, function () {
                              if (this.positionIndex == slide.positionIndex) {
                                returnSecondaries = true;
                                return false;
                              }
                            });
                            if (returnSecondaries) {
                              // This slide is one of the secondary slides chosen
                              return secondarySlides;
                            }

                            // This slide is not among the secondaries, just return it
                            var slides = [];
                            slides.push(slide);
                            return slides;
                          },
                          createBlank: function (vm, slideIdx, group) {
                            var slide = self.createSlide(vm, null, slideIdx);
                            if (group != undefined) {
                              // This blank may be inserted into a group
                              self.assignGroup(slide, group);
                            }
                            return slide;
                          },
                          setGroupProperties: function (vm) {
                            var slides = vm.getSlides(vm);

                            var prevGroupId = 0;
                            var lastSlideIdx = vm.numSlides - 1;

                            for (var slideIdx = 0; slideIdx < vm.numSlides; slideIdx++) {
                              var slide = slides[slideIdx];
                              if (slide.isValidSlide == false) {
                                // Filler slides from now on
                                break;
                              }
                              var groupId = slide.group.id();
                              var nextGroupId;
                              if (slideIdx < lastSlideIdx) {
                                nextGroupId = slides[slideIdx + 1].group.id();
                              } else {
                                nextGroupId = 0;
                              }

                              // Check for start
                              if (groupId === prevGroupId) {
                                slide.group.isStart(false);
                                slide.group.isMiddle(true);
                                slide.group.dispTitle(false);
                              } else {
                                slide.group.isStart(true);
                                slide.group.isMiddle(false);
                                slide.group.dispTitle(true);
                              }

                              // Check for end
                              if (groupId == nextGroupId) {
                                slide.group.isSingle(false);
                                slide.group.isEnd(false);
                                // slide.group.isMiddle(true); // leave to above setting
                              } else {
                                if (slide.group.isStart() == true) {
                                  slide.group.isSingle(true);
                                  slide.group.isStart(false);
                                  slide.group.isEnd(false);
                                } else {
                                  slide.group.isSingle(false);
                                  slide.group.isEnd(true);
                                }
                                slide.group.isMiddle(false);
                              }

                              prevGroupId = groupId;
                            }

                            // Always display title by first slide in each tray
                            for (slideIdx = 0; slideIdx < vm.numSlides; slideIdx += vm.settings.slidesPerTray) {
                              slides[slideIdx].group.dispTitle(true);
                            }
                          },
                          indexSlides: function (slides) {
                            // Ensure slides are indexed. Called in vm.putSlides
                            var positionIdx = 0;
                            $.each(slides, function () {
                              this.positionIndex = positionIdx;
                              positionIdx++;
                            });
                          },
                          sortSlides: function (slides) {
                            slides.sort(function (l, r) {
                              if (l.positionIndex < r.positionIndex) {
                                return -1;
                              }
                              if (l.positionIndex > r.positionIndex) {
                                return 1;
                              }
                              return 0;
                            });

                            // Ensure contiguous positions
                            var positionIdx = 0;
                            $.each(slides, function () {
                              this.positionIndex = positionIdx;
                              positionIdx++;
                            });
                          },
                          //  this is a method used to move a slide fromPos toPos.
                          moveSlide: function (vm, fromPos, toPos) {
                            var slides = vm.getSlides(vm);

                            //  get previous slides
                            var slideFrom = slides[fromPos];

                            //  remove the slide fromPos
                            slides.splice(fromPos, 1);

                            //  add the slide toPos
                            slides.splice(toPos, 0, slideFrom);
                          }
                          // End of vm initialization
                        };

        CurrentVm = vm;

        vm.updatePinnedCount = function (vm) {
          vm._dummyObservableForPinnedCountUpdate.notifySubscribers(); // force all subscribers to refresh
        };

        vm.pinnedCount = ko.dependentObservable(function () {
          this._dummyObservableForPinnedCountUpdate(); // retrieve and ignore the value; allows programmatic forcing of update
          var numberPinned = $.grep(vm.getSlides(vm), function (s) {
            return s.isMultiSlideSelected();
          }).length;
          return numberPinned;
        }, vm);

        vm.maxPinned = ko.dependentObservable(function () {
          return this.pinnedCount() >= 3;
        }, vm);

        vm.isMultiSlideEnabled = ko.dependentObservable(function () {
          this._dummyObservableForSettingsUpdate(); // retrieve and ignore the value; allows programmatic forcing of update
          return this.settings.displayMultiSlide;
        }, vm);

        vm.refreshSettings = function (vm) {
          vm._dummyObservableForSettingsUpdate.notifySubscribers(); // force all subscribers to refresh
        };

        vm.putSlidesIntoDisplayTray = function (vm) {
          var trayIdx = vm.displayTrayIdx();
          if (trayIdx == undefined) {
            return;
          }

          var displayTray = createEmptyTray(trayIdx);

          var startSlideIdx = trayIdx * vm.settings.slidesPerTray;
          var endSlideIdx = startSlideIdx + vm.settings.slidesPerTray;
          for (var i = startSlideIdx; i < endSlideIdx; i++) {
            if (i in vm.allSlides) {
              displayTray.slides.push(vm.allSlides[i]);
            }
          }

          if (vm.displayTray()) {
            if (vm.displayTray().slides().length > 0) {
              vm.displayTray().slides.removeAll();
            }
          }

          vm.displayTray(displayTray);
        };

        // Fill model with these slides
        vm.putSlides = function (vm, slides) {
          vm.allSlides = [];
          $.each(slides, function () {
            if (this.isValidSlide == true) {
              vm.allSlides.push(this);
            }
          });

          vm.indexSlides(vm.allSlides);

          vm.numTrays = Math.ceil(vm.allSlides.length / vm.settings.slidesPerTray);
          if (vm.numTrays == 0) {
            vm.numTrays = 1;
          }
          // Ensure all trays are full
          vm.numSlides = vm.numTrays * vm.settings.slidesPerTray;

          // Fill the remainder with blanks to ensure a full tray
          for (var i = vm.allSlides.length; i < vm.numSlides; i++) {
            vm.allSlides.push(vm.createBlank(vm, i));
          }

          vm.setGroupProperties(vm);

          vm.putSlidesIntoTrays(vm);

          if (vm.currentView === 'tray') {
            vm.putSlidesIntoDisplayTray(vm);
          } else if (vm.currentView === 'multi') {
            self.putSlidesIntoMulti(vm);
          }
        };

        // This method is somewhat obsolete.
        // It's only purpose now is to control the tray number display at the bottom of the DST
        vm.putSlidesIntoTrays = function (vm) {
          var numTrays = vm.activeCase().trays().length;

          while (numTrays < vm.numTrays) {
            var tray = createEmptyTray(numTrays);
            vm.activeCase().trays.push(tray);
            numTrays++;
          }

          while (numTrays > vm.numTrays) {
            vm.activeCase().trays.pop();
            numTrays--;
            // arizzini: fogbugz #  : making sure if we are removing the current tray that we set the correct visible.
            if (numTrays > 0 && numTrays == vm.displayTrayIdx()) {
              vm.displayTrayIdx(numTrays - 1);
            }
          }
        };

        // Called when user selects a case to open from the prior's dropdown
        vm.relatedCaseId.subscribe(function (val) {
          if (!ko.utils.unwrapObservable(val)) {
            return;
          }

          var newId = ko.utils.unwrapObservable(val).toString();
          if (newId == vm.activeCase().recordId) {
            return;
          }

          // Skip if we're on the current case panel
          if (vm.activeCase().isPrimaryCase) {
            return;
          }

          reloadSlides(vm.currentCase().recordId, newId);

          initializeDstAccordion(1, vm);
        });

        // Called whenever displayTrayIdx is changed
        vm.displayTrayIdx.subscribe(function (value) {
          var vm = getActiveViewModel();
          vm.putSlidesIntoDisplayTray(vm);
        });

        $.each(dstInfo.cases, function (iCase, caseElem) {
          var tempCase =
                            {
                              // priorCaseId : ko.observable(),
                              recordId: caseElem.recordId,
                              isActiveCase: caseElem.isActive,
                              isPrimaryCase: caseElem.isPrimaryCase,
                              relatedCases: function () {
                                var result = [];

                                $.each(vm.cases, function () {
                                  if (!this.isPrimaryCase) {
                                    result.push(this);
                                  }
                                });

                                return result;
                              },
                              title: caseElem.title,
                              trays: ko.observableArray(),
                              viewMode: ko.observable('slides')
                            };

          vm.slideCount['Case' + caseElem.recordId] = parseInt(caseElem.numImages.toString(), 10);

          tempCase.editTraysVm =
                            {
                              activeCase: vm.activeCase,
                              allSlides: [], // Describes the slides from every tray in one array (0 to 60 slides)
                              startTrayIndex: ko.observable(0),
                              endTrayIndex: ko.observable(0),
                              scroll: function (step) {
                                // User has hit Prev or Next link on multiTray page
                                self.putSlidesIntoMulti(vm, this.startTrayIndex() + step);
                              }
                            };

          tempCase.editTraysVm.enableScrollBackward = ko.dependentObservable(function () {
            return this.startTrayIndex() > 0;
          }, tempCase.editTraysVm);

          tempCase.editTraysVm.enableScrollForward = ko.dependentObservable(function () {
            return this.startTrayIndex() < (vm.numTrays - vm.settings.traysPerMulti);
          }, tempCase.editTraysVm);

          tempCase.editTraysVm.trays = ko.observableArray([]);

          tempCase.editTraysVm.cleanup = function () {
            var trays = this.trays;
            ko.utils.arrayForEach(trays(), function (tray) {
              tray.slides.removeAll();
            });

            trays.removeAll();
          };

          tempCase.toggleViewMode = function () {
            tempCase.viewMode(tempCase.viewMode() === 'slides' ? 'memos' : 'slides');

            // HACK: setting the visible bidinng didn't work when changing back from memos and slides, so I just did this manually
            $('.dst_slide-col-background', self).toggle(tempCase.viewMode() === 'slides');
          };

          vm.cases.push(tempCase);

          if (caseElem.isActive) {
            var slides = [];
            $.each(caseElem.slides, function () {
              slides.push(self.createSlide(vm, this, this.positionIndex));
            });

            vm.activeCase(tempCase);
            vm.putSlides(vm, slides);
            vm.displayTrayIdx(0);

            // If no recordId found on caseElem, default to something (1) to prevent undefined text from being appended to uniqueid
            vm.settings.uniqueId = dstSettings.divId + (caseElem.hasOwnProperty('recordId') ? caseElem.recordId : 1);
          }

          if (caseElem.isPrimaryCase) {
            vm.currentCase(tempCase);
          } else if (!vm.priorCase()) { // Select just the first prior case
            vm.priorCase(tempCase);
          }

          tempCase.summaryTitle = function () {
            if (tempCase.isPrimaryCase) {
              return tempCase.title;
            } else {
              return $t('prior-case') + tempCase.title;
            }
          };

          let summaryTitleWithSlideCount = '';
          tempCase.summaryTitleWithSlideCount = ko.dependentObservable(function () {
            var vm = getActiveViewModel();

            if (!vm.settings.summarySlidesOnly) {
              var result = tempCase.summaryTitle();
            } else {
              result = '';
            }

            if (!tempCase.isActiveCase) {
              const inactiveSlideCount = vm.slideCount['Case' + caseElem.recordId];
              return checkIfTitleChanged(`${result} - ${$t('inactive-slide-count-details', {readCount: inactiveSlideCount})}`);
            }

            var totalSlides = 0;
            var unreadSlides = 0;
            var slides = vm.getSlides(vm);
            $.each(slides, function () {
              if (this.isValidSlide == false) {
                return;
              }

              totalSlides++;

              if (!this.isRead()) {
                unreadSlides++;
              }
            });

            if (!vm.settings.summarySlidesOnly) {
              result += ' - ';
            }
            if (tempCase.isPrimaryCase) {
              result += $t('slide-read-count-details', {readCount: totalSlides.toString(), unreadCount: unreadSlides.toString()});
            } else {
              result += $t('slide-read-count-details', {readCount: totalSlides.toString(), unreadCount: unreadSlides.toString()});
            }

            return checkIfTitleChanged(result);

            function checkIfTitleChanged (newTitle) {
              if (summaryTitleWithSlideCount !== newTitle) {
                summaryTitleWithSlideCount = newTitle;
                if (tempCase.isActiveCase) {
                  vil.events.trigger('dst:summary-title-with-slide-count:change', summaryTitleWithSlideCount);
                }
              }
              return summaryTitleWithSlideCount;
            }
          });
        });

        vm.settings.infoDialogId = 'dst_InfoDialog_' + vm.settings.uniqueId;
        vm.settings.memoDialogId = 'dst_MemoDialog_' + vm.settings.uniqueId;

        // Tell the world (but let VIL do it) of the slide selected
        vm.selectImageNotification = function (vm, slide, prevSlide) {
          if (slide) {
            vil.VilImageSelected(slide, prevSlide);
            vm.waitForCompletion = slide.imageId;
          } else {
            vil.VilImageSelected(null);
          }

          //  fixed the issue of multiple corrupting resizes
          // $(this).resetSize(vm);
        };

        vm.setSelectedSlide = function (vm, slide, prevSlide, notify) {
          if (typeof notify === 'undefined') notify = true;

          if (vm.cantChangeSlide) {
            $.event.trigger(dstEventSlideChangeStopped);
            return false;
          }

          // Don't allow selection of 'invalid' slides (e.g., control slides, blank slides)
          if (!slide.isValidSlide || slide.isBlank) { // uncomment isBlank test to prevent selection of blank slides
            return false;
          }

          // Replace any current selection with this
          var currentSlide = ((prevSlide === undefined) ? vm.getSelectedSlide(vm) : prevSlide);
          if (currentSlide) {
            currentSlide.isSelected(false);
          } else if (prevSelectedSlide && prevSelectedSlide.isValidSlide) { // check if prior cases slide is stored
            currentSlide = prevSelectedSlide;
          }
          slide.isSelected(true);

          //  we need to add the record the selected slide.
          vm.selectedSlide = slide;

          if (notify) {
            vm.selectImageNotification(vm, slide, currentSlide);
          }

          // Clear all secondarys, then set this
          vm.clearSecondarySelections(vm);
          vm.toggleSecondarySelection(vm, slide);

          if (slide.trayIndex() != vm.displayTrayIdx()) {
            vm.displayTrayIdx(slide.trayIndex());
          }
          if (vm.settings.allowMultipleSelections == true) {
            slide.isSecondarySelected(true);
          }

          //
          // Set previous and next slide links
          //
          var slides = vm.getSlides(vm);
          var idx = slide.positionIndex;
          var prevSlideLink = vil.find('.prevSlideLink');
          var nextSlideLink = vil.find('.nextSlideLink');
          while (true) {
            idx--;
            if (idx < 0) {
              prevSlideLink.attr('class', 'prevSlideLink slide-nav-button-inactive');
              prevSlideLink.prop('disabled', true);
              break;
            }
            if (slides[idx].isBlank == false) {
              prevSlideLink.attr('class', 'prevSlideLink slide-nav-button-active');
              prevSlideLink.prop('disabled', false);
              break;
            }
          }
          var numSlides = slides.length;
          idx = slide.positionIndex;
          while (true) {
            idx++;
            if (idx >= numSlides) {
              nextSlideLink.attr('class', 'nextSlideLink slide-nav-button-inactive');
              nextSlideLink.prop('disabled', true);
              break;
            }
            if (slides[idx].isBlank == false) {
              nextSlideLink.attr('class', 'nextSlideLink slide-nav-button-active');
              nextSlideLink.prop('disabled', false);
              break;
            }
          }
        };

        // return slide that should be selected
        vm.selectSlide = function (vm) {
          var slide = vm.getSelectedSlide(vm);
          if (slide == null) {
            // If this tray was already displayed, select its last selected slide
            if (CaseSelectedSlides[vm.settings.uniqueId] != undefined) {
              var itemId = CaseSelectedSlides[vm.settings.uniqueId][vm.displayTrayIdx()];
              if (itemId != undefined) {
                $.each(vm.displayTray().slides(), function () {
                  if (this.itemId == itemId) {
                    vm.setSelectedSlide(vm, this);
                    slide = this;
                    return false;
                  }
                });
              }
            }
          }
          if (slide == null) {
            var allSlides = vm.getSlides(vm);
            //  Check if there is a selected slide on any tray (all slides)
            $.each(allSlides, function () {
              if (this.isSelected()) {
                vm.setSelectedSlide(vm, this);
                slide = this;
                return false;
              }
            });

            if (slide == null && vm.settings.autoSelectSlide) {
              // No selected image, or there are no images, or the previously selected slide was deleted
              // Just select the first slide on the current tray
              var visibleSlides = vm.getVisibleSlides(vm);
              $.each(visibleSlides, function () {
                if (this.isBlank == false) {
                  vm.setSelectedSlide(vm, this);
                  slide = this;
                  return false;
                }
              });
            }
          }
          return slide;
        };

        // Called whenever displayTray is changed
        vm.traySelected = ko.dependentObservable(function () {
          var vm = getActiveViewModel();
          return vm.displayTray();
        });

        // Called for every slide.isSelected(true/false) setting
        //              vm.getSelectedSlide = ko.dependentObservable(function()
        //              {
        //                  var slide = null;
        //                  var vm = getActiveViewModel();
        //                  // Display the slide that just got selected
        //                  $.each(vm.displayTray().slides(), function()
        //                  {
        //                      if (this.isSelected())
        //                      {
        //                          slide = this;
        //                          return false; // load only the first image if multiple selections
        //                      }
        //                  });
        //                  return slide;
        //              });

        vm.getSelectedSlide = function (vm) {
          return vm.selectedSlide;
        };

        vm.saveSelectedSlide = function () {
          var vm = getActiveViewModel();
          var slide = vm.getSelectedSlide(vm);
          if (slide != null) {
            if (CaseSelectedSlides[vm.settings.uniqueId] == undefined) {
              CaseSelectedSlides[vm.settings.uniqueId] = {};
            }
            CaseSelectedSlides[vm.settings.uniqueId][vm.displayTray().index] = slide.itemId;
            slide.isSelected(false);
          }
        };

        vm.toggleSecondarySelection = function (vm, slide) {
          if (vm.settings.allowMultipleSelections == true) {
            slide.isSecondarySelected(!slide.isSecondarySelected());
            var slides = vm.getSecondarySlides();
            if (slides.length > 1) {
              $.each(slide, function () {
                if (slide.isSelected() == true) {
                  slide.isSecondarySelected(true);
                  return false;
                }
              });
            }
          }
        };

        // Clear all secondary selections
        vm.clearSecondarySelections = function (vm) {
          // only deselect selected slides - avoid the subscription callbacks
          var slides = vm.getSecondarySlides();
          $.each(slides, function () {
            this.isSecondarySelected(false);
          });
        };

        // Clear all open windows
        vm.close = function (vm) {
          // Remove lingering info dialog
          $('#' + vm.settings.infoDialogId).dialog('close');

          // Remove lingering memo dialog
          $('#' + vm.settings.memoDialogId).dialog('close');

          // Remove lingering edit tray
          $('div.dst_EditTrays').dialog('close');
        };

        if (CurrentVm.currentCase() == undefined) {
          // XXX this is temporary pending a DataServer fix
          alert($t('no-current-case-defined-alert'));
          CurrentVm.currentCase(CurrentVm.activeCase());
        }

        vm.createContextMenu(vm);

        // Create and render the html
        var html = dstHtmlTemplate(vm);
        ko.cleanNode(this); // remove bindings so we can reapply
        $(this).html(html);

        $('.dst_container', self).data('divId', vm.settings.divId);

        ko.applyBindings(vm, this);

        // Accordion behavior
        if (renderMode === 'viewer') {
          initializeDstAccordion(isPrimaryCase ? 0 : 1, vm);
        }

        addEventHandlers(vm);

        // Ensure each div has only one vm
        ViewModels[vm.settings.divId] = vm;
      });

      initializeInfoDialog(CurrentVm.settings);

      initializeMemoDialog(CurrentVm.settings);

      if (dstSettings.onComplete) {
        dstSettings.onComplete();
      }

      // End of render()
    };

    /*************************************************************************************************************
         END RENDER
         *************************************************************************************************************/

    /**
         *
         * @param {object} dstSettings
         * @returns {undefined}
         */
    var addHoverBehavior = function (dstSettings) {
      // Show oversized label popup
      if (dstSettings.enableLabelPopup) {
        // Add an jQuery UI tool-tip to label to pop up native res label image
        // tooltip-applied class used to prevent applying widget more than once
        $('.dst_tray .dst_slide-holder-label:not(.tooltip-applied)').addClass('tooltip-applied').tooltip({
          items: 'img',
          content: function () {
            return '<img src ="' + $(this).attr('src') + '">';
          },
          position: { my: 'left top', at: 'right bottom', of: this, collision: 'fit' },
          open: function (event, ui) {
            if (ui.tooltip) {
              ui.tooltip.addClass(constants.popupLabelCssClass);
              ui.tooltip.addClass(constants.rotationClassPrefix + getActiveViewModel().labelRotation);
            }
          }
        });
      }

      // Size figures based on slide dimension 124 x 38,
      // hovered height 60,
      // 2.25X hovered size = 176.7 x 60

      //  increasing the HoverThumbnail

      var DURATION = 300;
      var HOVER_LEFT_STRING = '-29px'; // (124 - 176.7) / 3
      var HOVER_TOP_STRING = '-13px'; // (38 - 60) / 2
      var HOVER_WIDTH_STRING = '211px';
      var HOVER_HEIGHT_STRING = '65px';

      if (!dstSettings.enableEnhancedView) {
        return;
      }

      $('.dst_slide-holder:not(.dst_slide-placeholder)', self).hoverIntent(
        {
          over: function () {
            if (!$.getDstInstance().getActiveViewModel().settings.enableEnhancedView) {
              return;
            }
            $(this).css('z-index', 200); // as soon as we hover, make z-index higher than the multi-slide selector (or it shows through momentarily and looks wierd)
            $(this).data('HoverAnimating', true).animate(
              {
                top: HOVER_TOP_STRING,
                left: HOVER_LEFT_STRING,
                height: HOVER_HEIGHT_STRING,
                width: HOVER_WIDTH_STRING,
                zIndex: 200

              }, DURATION, function () {
                // $(this).css('z-index', 9999);
                $(this).removeData('HoverAnimating');
              });

            $(this).children('div').animate(
              {
                height: HOVER_HEIGHT_STRING
              }, DURATION);
          },
          out: function () {
            if (!$.getDstInstance().getActiveViewModel().settings.enableEnhancedView) {
              return;
            }

            $(this).animate(
              {
                top: '0px',
                left: '6px',
                height: '38px',
                width: '124px',
                zIndex: 99

              }, DURATION, function () {
                // $(this).css('z-index', '');
                $(this).removeClass('dst_hovered-slide-holder');
              });

            $(this).children('div').animate(
              {
                height: '38px'
              }, DURATION);
          }
        });
    };

    // Hot keys
    var addEventHandlers = function (vm) {
      var dst = $('#' + vm.divId);
      // First unbind any existing handlers to prevent multiple callbacks
      dst.unbind('keyup');
      vil.unbind('vil_evIMAGEREADY');

      // Note that focus must be on the dst.
      dst.off('.dst'); // unbind previous bindings for dst namespace (only used here as of 4.24.14)
      dst.on('keydown' + '.dst' + ' keyup' + '.dst', function (e) {
        // disable browser zoom (ctrl +/-)
        if (e.ctrlKey) {
          if (e.keyCode === 107 || e.keyCode === 187) { // plus
            e.preventDefault();
          } else if (e.keyCode === 109 || e.keyCode === 189) { // minus
            e.preventDefault();
          }
        }
      });

      // Capture key up events. tabindex enables focus on the dstDiv.
      dst.attr('tabIndex', 1).bind('keyup', function (event) {
        //              var vm = getActiveViewModel();

        // var targetId = event.target.parentNode.id;

        if ((event.ctrlKey) && (event.altKey)) {
          if (event.keyCode === 39) { // right
            vm.moveNextSlide();
          } else if (event.keyCode === 37) { // left
            vm.movePrevSlide();
          } else if (event.keyCode === 82) { // r
            vm.toggleReadSelectedSlides(vm);
          }
        }
        // handle q/Q and e/E for prev next
        // TODO: skip this handler if memo or info dialog open
        if (event.keyCode === 69) { // e/E, next slide
          vm.moveNextSlide();
        } else if (event.keyCode === 81) { // q/Q - prev slide
          vm.movePrevSlide();
        }
      });

      // Capture process completions from VIL
      vil.bind('vil_evIMAGEREADY', function (event, parms) {
        var vm = getActiveViewModel();
        var imageId = parms.imageId.substring(1);
        if (imageId == vm.waitForCompletion) {
          // $("#" + vm.divId).focus(); // this caused the pop-up header to dissappearin Chrome -cb 4.30.15
          vm.waitForCompletion = 0;
          // Close any open memo or info dialogs so we don't get out of sync while switching images
          $('#' + vm.settings.infoDialogId + '.ui-dialog-content').filter(':visible').dialog('close');
          $('#' + vm.settings.memoDialogId + '.ui-dialog-content').filter(':visible').dialog('close');
          return true;
        }
      });
    };

    var createEmptyTray = function (iTray) {
      var vm = getActiveViewModel();
      var tray =
                    {
                      changeTray: function (trayIdx) {
                        var vm = getActiveViewModel();

                        // Save selected slide from current tray
                        vm.saveSelectedSlide();

                        // Load new tray
                        vm.displayTrayIdx(trayIdx);

                        if (vm.settings.enableMultiTray) {
                          dstEditTray(vm.settings);
                        }
                        vm.selectSlide(vm);
                      },
                      columns: [],
                      index: iTray,
                      slides: ko.observableArray()
                    };

      tray.isTrayRead = ko.dependentObservable(function () {
        var result = true;

        $.each(tray.slides(), function (key, value) {
          if (!value) {
            return; // protect against undefined items in the slides() observable array
          }
          if (this.isValidSlide == false) {
            return;
          }

          if (!this.isRead()) {
            result = false;
            return false;
          }
        });

        return result;
      });

      tray.slideInfo =
                    {
                      show: function (vm, slide) {
                        var slides = vm.getChosenSlides(vm, slide);
                        var result = this.collectInfo(slides);
                        var str = "<div class='dst_slide-info-wrapper'>";
                        let slideInfoKey = null;
                        let translatedSlideInfoKey = null;
                        $.each(result, function (iResult) {
                          // To apply localization, make sure each key in the slide info array is converted into the appropriate translation key
                          // Convert the string to lowercase and replace whitespace with a '-'. Also, remove all leading and trailing whitespaces.
                          // Example: Barcode Id has to be converted to barcode-id
                          slideInfoKey = this.name.trim().replace(/\s+/g, '-').toLowerCase();
                          translatedSlideInfoKey = $t('slide-info.' + slideInfoKey);
                          str += "<div class='dst_slide-info'>";
                          str += "    <div class='dst_slide-info-key'> " + translatedSlideInfoKey + ' </div>';
                          // No translation required for the slide info value as this is entered by the user
                          str += "    <div class='dst_slide-info-value'> " + this.value + ' </div>';
                          str += '</div>';
                        });
                        str += '</div>';

                        var infoDialog = $('#' + vm.settings.infoDialogId);
                        if (!(infoDialog.dialog('isOpen') === true)) {
                          infoDialog.html(str);
                          infoDialog.dialog('option', 'title', vm.activeCase().summaryTitle()).dialog('open');
                        } else {
                          infoDialog.dialog('close');
                        }
                      },
                      collectInfo: function (slides) {
                        if (slides.length === 0) {
                          return [];
                        }

                        // Merge the info property from the slides in slides array into result
                        if (slides[0].info === undefined) {
                          slides[0].info = [];
                        }
                        var result = cloneDeep(slides[0].info);

                        for (var i = 1; i < slides.length; i++) {
                          // More than one slide selected, if values differ mark as various
                          if (slides[i].info === null) {
                            slides[i].info = [];
                          }

                          $.each(slides[i].info, function (iInfo, info) {
                            $.each(result, function (iResult) {
                              if (this.value === constants.various) {
                                return; // Skip if already VARIOUS
                              }
                              if (info.name === this.name) {
                                if (info.value !== this.value) {
                                  result[iResult].value = constants.various;
                                }
                              }
                            });
                          });
                        }

                        return result;
                      }
                    };

      tray.slideMemo =
                    {
                      displayedSlides: [],
                      show: function (vm, slide) {
                        var memoDialog = $('#' + vm.settings.memoDialogId);
                        displayedSlides = vm.getChosenSlides(vm, slide);
                        var result = displayedSlides[0].memoContent();
                        $.each(displayedSlides, function () {
                          if (this.memoContent() !== result) {
                            result = constants.various;
                            return false;
                          }
                        });
                        // If the dialog is not open, load the text area and open it
                        if (!(memoDialog.dialog('isOpen') === true)) {
                          memoDialog.find('textarea').val(result);
                          memoDialog.dialog('option', 'title', vm.activeCase().summaryTitle()).dialog('open');
                        } else { // if the dialog is already open, and the contents have not changed, close it. This facilitates quick open / close of memo by clicking on the memo icon
                          if (result == memoDialog.find('textarea').val()) {
                            memoDialog.dialog('close');
                          }
                        }
                      },
                      save: function (value) {
                        if (value === constants.various) {
                          return;
                        }

                        $.each(displayedSlides, function () {
                          this.memoContent(value);
                        });

                        vm.trayIsModified = true;
                      }
                    };

      return tray;
    };

    // User selected/deselected a slide
    var doToggleSelectedStatus = function (event, ui) {
      var vm = getActiveViewModel();
      if (vm.cantToggleSlide) {
        return;
      }

      if (this.isMultiSlideSelected()) {
        return;
      }

      var intervalId;
      var that = this;

      intervalId = setInterval(function () {
        var $slideHolder = $(event.target).parent();

        if ($slideHolder.data('HoverAnimating')) {
          return;
        }

        clearInterval(intervalId);

        if (event.ctrlKey) {
          // <ctrl> Left/Right click
          vm.toggleSecondarySelection(vm, that);
        } else {
          // Left click
          vm.setSelectedSlide(vm, that);
        }

        vm.addSlideBehaviors();
      }, 100);
    };

    var getContextSlide = function (event, context) {
      var vm = getActiveViewModel();
      var $slideHolder = $(context);
      var col = $slideHolder.closest('ul').hasClass('dst_slide-col-1') ? 0 : 1;
      var pos = $slideHolder.closest('li').index();

      var slide;
      if (vm.currentView === 'multi') {
        var trayIdx = $slideHolder.closest('.dst_tray').parent().index();
        slide = vm.getVisibleSlide(vm, col, pos, trayIdx);
      } else {
        slide = vm.getVisibleSlide(vm, col, pos);
      }

      return slide;
    };

    var reloadSlides = function (primaryId, priorId) {
      var promise = {};
      var vm = getActiveViewModel();
      vm.isBusy(true); // this does not work yet because the ko bindings are being completely redone below
      // TODO: don't redo the bindings - use a put slides method instead that just reloads the slides array
      $('.ui-accordion-content', self).spin('large');

      // Save selected slides for use when switching between case tabs
      vm.saveSelectedSlide();

      prevSelectedSlide = vm.getSelectedSlide(vm); // this is a global

      promise = vil.loadSlides(primaryId, priorId);

      $.when(promise).always(function () {
        $('.ui-accordion-content', self).spin(false);
        vm.isBusy(false);
      });
    };

    var initializeDstAccordion = function (activeIndex, vm) {
      if ($('.dst_accordion', self).is(':ui-accordion')) {
        $('.dst_accordion', self).accordion('destroy');
      }

      $('.dst_accordion', self).accordion(
        {
          active: activeIndex,
          event: 'click hoverintent',
          heightStyle: 'auto',
          activate: function (event, ui) {
            if ($(this).accordion('option', 'active') === 0) {
              reloadSlides(vm.currentCase().recordId);
            } else {
              reloadSlides(vm.currentCase().recordId, vm.priorCase().recordId);
            }
          }
        });
    };

    var initializeInfoDialog = function (dstSettings) {
      $('#' + dstSettings.infoDialogId).dialog(
        {
          autoOpen: false,
          buttons:
                                [
                                  {
                                    text: $t('close'),
                                    click: function () {
                                      $(this).dialog('close');
                                    }
                                  }
                                ],
          closeText: $t('close'),
          height: 300,
          width: 450
        });
    };

    var initializeMemoDialog = function (dstSettings) {
      $('.dst_memo-tooltip').tipTip({edgeOffset: 6});
      var memoDialog = $('#' + dstSettings.memoDialogId);
      memoDialog.dialog(
        {
          autoOpen: false,
          buttons: [
            {
              text: $t('save'),
              click: function () {
                var textArea = $(this).find('textarea');
                var vm = getActiveViewModel();
                var memoText = textArea.val();
                if (memoText == '') {
                  // Currently tiptip does not clear a string, just blank it out
                  memoText = ' ';
                }

                vm.displayTray().slideMemo.save(memoText); // this just saves to memory

                // This will re-init all tiptips after title attribute on selected slide(s) is updated
                $('.dst_memo-tooltip').tipTip({edgeOffset: 6});
                // TODO: We are saving the entire DST here. It would be more effcient to save just this memo. -ccb
                memoDialog.spin();
                $.when(vil.saveDSTifModified()).done(function () {
                  memoDialog.dialog('close');
                }).always(function () {
                  memoDialog.spin(false);
                });
              }
            },
            {
              text: $t('cancel'),
              click: function () {
                $(this).dialog('close');
              }
            }
          ],
          close: function () {

          },
          closeText: $t('close'),
          height: 300,
          width: 350
        });

      $.extend($.ui.dialog.prototype,
        {
          'removebutton': function (buttonName) {
            var buttons = this.element.dialog('option', 'buttons');
            delete buttons[buttonName];
            this.element.dialog('option', 'buttons', buttons);
          }
        });

      if (dstSettings.allowMemoEdit == false) {
        memoDialog.dialog('removebutton', 'Save');
      }
    };

    var insertBlankSlide = function (vm, insertPos, group, isMultiTray) {
      var newSlides = [];
      var currentSlides = vm.getSlides(vm);
      $.each(currentSlides, function () {
        if (this.positionIndex == insertPos) {
          newSlides.push(vm.createBlank(vm, insertPos, group));
          this.positionIndex++;
        } else if (this.positionIndex > insertPos) {
          this.positionIndex++;
        }
        newSlides.push(this);
      });

      vm.putSlides(vm, newSlides);
    };

    var removeHoverBehavior = function (event) {
      var intervalId;
      var $elem = $(event.target).closest('.dst_slide-holder');

      intervalId = setInterval(function () {
        if ($elem.data('HoverAnimating')) {
          return;
        }

        clearInterval(intervalId);

        $elem.css('position', '').css('left', '').css('top', '');
      }, 100);
    };

    /*************************************************************************************************************
         PUBLIC FUNCTIONS -- these are the functions which publicly available on the DST instance
         *************************************************************************************************************/

    /**
         * If the global prevSelectedSlide (used for switching between prior cases) is no longer present as the unpoinned image in uScope, clear it
         * @returns {unresolved}
         */
    self.clearPrevSelectedSlide = function () {
      if (prevSelectedSlide) {
        var matchingUnpinned = vil.uScope.getImageState().filter(function (image) {
          return !image.isPinned && (image.imagePath == prevSelectedSlide.encodedImageId);
        });
        if (matchingUnpinned.length < 1) {
          prevSelectedSlide = null;
        }
      }
    };

    self.getActiveViewModel = function () {
      return getActiveViewModel();
    };

    /**
         * Get summary title with slide read count from currently active view model
         * @returns {string}
         */
    self.summaryTitleWithSlideCount = function () {
      return getActiveViewModel().activeCase().summaryTitleWithSlideCount();
    };

    self.lockSlideChange = function (lock) {
      var vm = getActiveViewModel();
      vm.cantChangeSlide = lock;
    };

    self.putSlidesIntoMulti = function (vm, startIndex) {
      // TODO: make start and end index consistent; start index is 0 based, but end index is one based

      var deferred = new $.Deferred();

      $('#dst_EditTrays').spin('large');
      // Set timeout is needed to allow time for browser to update the spinner before the intensive operations to follow
      setTimeout(function (vm, startIndex) {
        var startTrayIdx = (typeof startIndex !== 'undefined') ? startIndex : vm.activeCase().editTraysVm.startTrayIndex();

        if (startTrayIdx == undefined) {
          return;
        }

        vm.activeCase().editTraysVm.cleanup();

        var endTrayIdx = startTrayIdx + vm.settings.traysPerMulti;
        if (endTrayIdx >= vm.numTrays) {
          endTrayIdx = vm.numTrays;
        }

        // update the observables
        vm.activeCase().editTraysVm.endTrayIndex(endTrayIdx);
        vm.activeCase().editTraysVm.startTrayIndex(startTrayIdx);

        var numEditTrays = vm.activeCase().editTraysVm.trays().length;

        var allSlides = vm.getSlides(vm);

        var slide;
        var srcSlideIdx = startTrayIdx * vm.settings.slidesPerTray;
        var endSrcSlideIdx = 0;
        var multiTrayIdx = 0;
        var tray;
        for (var srcTrayIdx = startTrayIdx; srcTrayIdx < endTrayIdx; srcTrayIdx++) {
          if (multiTrayIdx < numEditTrays) {
            tray = vm.activeCase().editTraysVm.trays()[multiTrayIdx];
          } else {
            tray = createEmptyTray(multiTrayIdx);
            vm.activeCase().editTraysVm.trays.push(tray);
          }
          var slidesRef = tray.slides();
          if (slidesRef.length > 0) {
            slidesRef.splice(0); // clear out previous slides in underlying array
          }
          endSrcSlideIdx = srcSlideIdx + vm.settings.slidesPerTray;
          while (srcSlideIdx < endSrcSlideIdx) {
            if (srcSlideIdx < allSlides.length) {
              slide = allSlides[srcSlideIdx];
            } else {
              slide = vm.createBlank(vm, srcSlideIdx);
            }
            slidesRef.push(slide); // push to underlying slides array (faster than using observable array)
            srcSlideIdx++;
          }
          multiTrayIdx++;
          tray.slides.valueHasMutated(); // Tell KO that the observable array has refreshed
        }

        // TODO: this next test looks supicious
        if (endTrayIdx < numEditTrays) {
          // User has deleted slides/blanks to where a tray no longer has a valid slide
          // Remove the trays, so they do not display when window is opened again
          for (var iTray = endTrayIdx; iTray < numEditTrays; iTray++) {
            vm.activeCase().editTraysVm.trays().pop();
          }
        }
        $('#dst_EditTrays').spin(false);
        deferred.resolve();
      }, 100, vm, startIndex); // TODO: find a better way to handle spinner; perhaps switch to setImmediate
      return deferred.promise();
    };

    // Place this slide into the list
    self.putSlide = function (vm, slide, positionIdx) {
      var theCase = vm.activeCase();
      if (positionIdx < vm.numSlides) {
        vm.allSlides[positionIdx] = slide;
        if (vm.currentView == 'multi') {
          var iTray = Math.floor(positionIdx / vm.settings.slidesPerTray) - theCase.editTraysVm.startTrayIndex();
          if (iTray < theCase.editTraysVm.trays().length) {
            var tray = theCase.editTraysVm.trays()[iTray];
            var trayIdx = positionIdx % vm.settings.slidesPerTray;
            tray.slides()[trayIdx] = this;
          }
        }
      }
    };

    $.fn.reorderSlides = function (vm, fromPos, toPos) {
      var startWindow, endWindow, counter;
      if (fromPos <= toPos) {
        startWindow = fromPos;
        endWindow = toPos;
        counter = startWindow;
      } else if (fromPos >= toPos) {
        startWindow = toPos;
        endWindow = fromPos;
        counter = startWindow;
      } else { // fromPos == toPos
        // Slide not moved, Invalid window
        return;
      }

      var slides = vm.getSlides(vm);

      $.each(slides, function () {
        if (this.isValidSlide == true) {
          var slidePos = parseInt(this.positionIndex, 10);

          if (startWindow <= slidePos && slidePos <= endWindow) {
            this.positionIndex = counter++;
          } else {
          }
        }
      });

      vm.putSlides(vm, slides);

      vm.trayIsModified = true;
    };

    // Create a new slide
    self.createSlide = function (vm, srcSlide, position) {
      var slide;

      var memoContent = '';

      if (srcSlide == null) {
        slide =
                        {
                          itemId: '',
                          imageId: '',
                          encodedImageId: '',
                          info: '',
                          isRead: ko.observable(false),
                          isMultiSlideSelected: ko.observable(false),
                          //  property to track where the slides comes from in PeerReview.
                          originated: '',
                          sampleType: '',
                          fullURL: '',
                          isPinned: false,
                          isBlank: true,
                          hasMemo: false,
                          SaveAnnotation: false,
                          ViewLabel: false,
                          SaveMacro: false,
                          RunAnalysis: false,
                          removeHoverBehavior: function (event) {
                            removeHoverBehavior(event);
                          },
                          showInfo: function () {
                          },
                          showMemo: function () {
                          },
                          clickMultiSlide: function () {
                          },
                          thumbnailImageSrc: '',
                          thumbnailLabelSrc: '',
                          toggleSelectedStatus: function (event, ui) {
                            doToggleSelectedStatus.call(this, event, ui);
                          }
                        };
        self.assignGroup(slide);
      } else {
        // Unwrap items (if they are already observables) that should be transferred
        var isRead = ko.utils.unwrapObservable(srcSlide.isRead);
        memoContent = ko.utils.unwrapObservable(srcSlide.memo);
        if (memoContent == undefined) {
          // Blank slide
          memoContent = '';
        }
        var imageId = (('imageId' in srcSlide) && (srcSlide.imageId)) ? srcSlide.imageId : '';
        slide =
                        {
                          itemId: srcSlide.itemId,
                          imageId: imageId,
                          encodedImageId: (srcSlide.imageId) ? '@' + imageId : '',
                          info: srcSlide.info,
                          isRead: ko.observable(isRead),
                          isMultiSlideSelected: ko.observable(ko.utils.unwrapObservable(srcSlide.isMultiSlideSelected)),
                          fullURL: srcSlide.fullURL,
                          //  property to track where the slides comes from in PeerReview.
                          originated: srcSlide.originated,
                          sampleType: 'patient',
                          isPinned: false,
                          SaveAnnotation: srcSlide.SaveAnnotation,
                          ViewLabel: srcSlide.ViewLabel,
                          SaveMacro: srcSlide.SaveMacro,
                          removeHoverBehavior: function (event) {
                            removeHoverBehavior(event);
                          },
                          showInfo: function (event) {
                            var vm = getActiveViewModel();
                            vm.displayTray().slideInfo.show(vm, this);
                          },
                          showMemo: function (event) {
                            var vm = getActiveViewModel();
                            if (dstSettings.allowMemoEdit) {
                              $('.dst_MemoDialog textarea').removeAttr('readonly').removeAttr('disabled');
                            } else {
                              $('.dst_MemoDialog textarea').attr('readonly', 'readonly').attr('disabled', 'disabled');
                            }
                            vm.displayTray().slideMemo.show(vm, this);
                          },
                          thumbnailImageSrc: srcSlide.thumbnailImageSrc,
                          thumbnailLabelSrc: vm.settings.displayLabels ? srcSlide.thumbnailLabelSrc : '/Viewer/DST/images/slide_blank_label.png',
                          toggleSelectedStatus: function (event, ui) {
                            doToggleSelectedStatus.call(this, event, ui);
                          }
                        };

        if (srcSlide.slideId != 0) {
          slide.isBlank = false;
          if (slide.imageId != 0) {
            slide.hasMemo = true;
          } else {
            // Memos are associated with the image, not the slide
            slide.hasMemo = false;
          }
        } else {
          slide.isBlank = true;
          slide.hasMemo = false;
        }

        self.assignGroup(slide, srcSlide.group);
      }
      ;

      slide.isMultiSlideSelected.subscribe(function (newValue) {
        if (newValue === true) {
          // we need to sent this slide to the viewer.
          this.isPinned = true; // this property must be set BEFORE calling uScopeImageUpdate
          if (!vil.uScopeImageUpdate('add', {'image': this})) {
            this.isPinned = false;
          }
        } else if (this.isPinned) {
          // we already have sent this to the viewer we need to remove it.
          if (vil.uScopeImageUpdate('remove', {'image': this})) {
            this.isPinned = false;
          }
        }
        var vm = getActiveViewModel();
        vm.updatePinnedCount(vm); // this is necessary to update subscribers to pinnedCount (and maxPinned)
      }, slide);

      slide.trayIndex = function () {
        return Math.floor(this.positionIndex / vm.settings.slidesPerTray);
      };

      slide.positionIndex = parseInt(position, 10); // Index of slide across entire case
      slide.isDragged = ko.observable(false);
      slide.isDraggedOver = ko.observable(false);

      slide.isSelected = ko.observable(false);
      slide.isSelected.subscribe(function () {
        this.setDisplayMemoIcon();
      }, slide);

      slide.isSecondarySelected = ko.observable(false);
      slide.isSecondarySelected.subscribe(function () {
        this.setDisplayMemoIcon();
      }, slide);

      slide.memoContent = ko.observable(memoContent);
      slide.memoContent.subscribe(function (value) {
        this.setDisplayMemoIcon();
      }, slide);

      // displayMemoIcon must be an observable (as opposed to a function) in order to rerender the icon when blanked
      slide.displayMemoIcon = ko.observable(false);
      slide.setDisplayMemoIcon = function () {
        this.displayMemoIcon(false);

        if (dstSettings.displayMemos == false) {
          return;
        }
        if (this.hasMemo == false) {
          return;
        }

        if (this.isSelected() || this.isSecondarySelected()) {
          this.displayMemoIcon(true);
        }
        var memoContent = this.memoContent();
        if (this.isSecondarySelected() || (memoContent.length > 1)) {
          this.displayMemoIcon(true);
        } else if ((memoContent.length == 1) && (memoContent != ' ')) {
          this.displayMemoIcon(true);
        }
        // else since we cannot save a null string, a single blank is considered empty
      };
      slide.setDisplayMemoIcon();

      // Return memo for "View All Memos" page
      slide.trimmedMemo = ko.dependentObservable(function () {
        var str = slide.memoContent();

        if (!str) {
          return null;
        }

        var lines = str.split('\n');
        var numLines = lines.length;
        if (numLines > 3) {
          lines.splice(3);
          numLines = 3;
        }
        for (var i = 0; i < numLines; i++) {
          if (lines[i].length > 18) {
            lines[i] = lines[i].substring(0, 15) + '...';
          }
        }

        str = lines.join('\n');

        return str;
      });

      return slide;
    };

    self.assignGroup = function (slide, srcGroup) {
      var id, title;
      if (srcGroup === undefined) {
        id = 0;
        title = '';
      } else {
        id = ko.utils.unwrapObservable(srcGroup.id);
        title = ko.utils.unwrapObservable(srcGroup.title);
      }
      slide.group =
                    {
                      id: ko.observable(id),
                      title: ko.observable(title),
                      isStart: ko.observable(false),
                      isMiddle: ko.observable(false),
                      isEnd: ko.observable(false),
                      isSingle: ko.observable(false),
                      dispTitle: ko.observable(false)
                    };
      slide.groupId = id;
      if (id > 0) {
        slide.isValidSlide = true;
      } else {
        slide.isValidSlide = false;
      }
    };

    self.getSettings = function () {
      var vm = getActiveViewModel();
      vm.settings.that = self;
      return vm.settings;
    };

    self.putSettings = function (newSettings) {
      var vm = getActiveViewModel();
      vm.settings = newSettings;
      dstSettings = newSettings;
      self = vm.settings.that;
    };

    self.renderDST = function (dstInfo, options, isPrimaryCase) {
      if (options) {
        $.extend(dstSettings, options);
      }

      if (dstSettings.lockMode == true) {
        dstSettings.enableReordering = false;
        dstSettings.allowContextMenu = false;
        dstSettings.allowMemoEdit = false;
      }

      if (dstSettings.iosMode == true) {
        dstSettings.enableReordering = false;
        dstSettings.allowContextMenu = false;
        dstSettings.allowMultipleSelections = false;
      }

      if (dstSettings.enableReordering == false) {
        dstSettings.enableMultiTray = false;
      }

      renderMode = 'viewer';
      render(dstInfo, dstSettings, isPrimaryCase);
    };

    // Called from VIL
    self.selectDefaultSlide = function () {
      var vm = getActiveViewModel();
      var slide = vm.selectSlide(vm);
      if (slide == null) {
        // Clear any modules dependent on this slide, eg. uScope
        vm.selectImageNotification(vm, null);
      } else {
        // this enables the hover event on the selected slide
        // without this, the hover event is not sent to the slide.
        // $('.dst_selected-slide-holder').click(); // update: this can cause all kinds of problems when switching tabs in Network (HC) -cb
        // not sure init of slide behaviors is still needed here; if so, just uncomment line below  -cb
        // vm.addSlideBehaviors();
      }
    };

    self.selectImageByImageId = function (imageId, notify = true) {
      var slide = null;
      var vm = getActiveViewModel();
      var allSlides = vm.getSlides(vm);
      $.each(allSlides, function () {
        if (this.imageId == imageId) {
          // Note= this will reselect the image if it was already selected to force its viewing
          slide = this;
          return false;
        }
      });
      if (slide != null) {
        vm.setSelectedSlide(vm, slide, undefined, notify);
      } else {
        if (notify) {
          vm.selectImageNotification(vm, null);
        }
      }
    };

    self.serialize = function () {
      var vm = getActiveViewModel();

      var i, result;
      var tableItem = vm.activeCase();
      var allSlides = vm.getSlides(vm);

      // Find the last valid slide
      var maxPos = null;
      for (i = allSlides.length - 1; i >= 0; i--) {
        if (allSlides[i].isValidSlide) {
          maxPos = i;
          break;
        }
      }

      result =
                    {
                      Id: vm.dstId,
                      TableName: vm.tableName,
                      RecordId: tableItem.recordId,
                      Images: []
                    };

      if (maxPos != null) {
        // Save all slides
        for (i = 0; i <= maxPos; i++) {
          var srcSlide = allSlides[i];
          var saveSlide =
                            {
                              Id: srcSlide.itemId,
                              ImageId: srcSlide.imageId,
                              PositionIndex: srcSlide.positionIndex,
                              GroupId: srcSlide.group.id(),
                              State: 'Unmodified'
                            };
          saveSlide.Memo = srcSlide.memoContent();
          /**
                    if (saveSlide.Memo == "") {
                        // This is already done, see tiptip
                        saveSlide.Memo = " ";
                    }
          **/
          result.Images.push(saveSlide);
        }
      }

      $.each(vm.deletedSlides, function () {
        result.Images.push(
          {
            Id: this.itemId,
            ImageId: this.imageId,
            PositionIndex: '',
            GroupId: '',
            Memo: '',
            State: 'Deleted'
          });
      });

      return ko.toJSON(result);
    };

    self.isModified = function () {
      var vm = getActiveViewModel();
      return vm.trayIsModified;
    };

    self.clearModified = function () {
      var vm = getActiveViewModel();
      vm.deletedSlides.splice(0);
      vm.trayIsModified = false;
    };

    // called on image navigated event
    self.toggleRead = function (slideId, isRead) {
      var vm = getActiveViewModel();

      var slide;
      var slides = vm.getSlides(vm);
      $.each(slides, function () {
        if (this.imageId == slideId) {
          slide = this;
          return false;
        }
      });

      if (!slide) {
        return;
      }

      var status;
      if (isRead === undefined) {
        status = !slide.isRead();
      } else {
        status = isRead;
      }

      slide.isRead(status);

      return this;
    };

    self.close = function () {
      var vm = getActiveViewModel();
      vm.close(vm);
    };

    /**
         * Prevent users from selecting slides
         * Stores previous state so that selection can be toggled
         */
    self.disableSlideSelection = function () {
      getActiveViewModel().cantToggleSlide = true;
    };
    /**
         * Allow users to select slides
         * Restores previous state so that selection can be toggled
         */
    self.enableSlideSelection = function () {
      getActiveViewModel().cantToggleSlide = false;
    };
    /**
         * Hide the next/previous buttons
         */
    self.hideNextPreviousButtons = function () {
      $('div.slide-nav').hide();
    };
    /**
         * Show the next/previous buttons
         */
    self.showNextPreviousButtons = function () {
      $('div.slide-nav').show();
    };
    /**
         * Enable enhanced view  (magnification of the slide on hover)
         */
    self.enableEnhancedView = function () {
      $.getDstInstance().getActiveViewModel().settings.enableEnhancedView = true;
      $.getDstInstance().getActiveViewModel().addSlideBehaviors();
    };
    /**
         * Disable enhanced view
         */
    self.disableEnhancedView = function () {
      $.getDstInstance().getActiveViewModel().settings.enableEnhancedView = false;
      $.getDstInstance().getActiveViewModel().addSlideBehaviors();
    };

    self.rotateDstLabelsPopup = function ({newDegree}) {
      getActiveViewModel().labelRotation = newDegree;
    };
    // Start plugin
    return this;
  };
})(jQuery);

var dstHtmlTemplate = function (vm) {
  var dstSettings = vm.settings;
  var html =
            // Tray divider / collapse link

            "   <div class='dst_case' data-bind='template: { afterRender: addCaseBehaviors, name: \"dst_CaseTemplate\" }'> </div>" +
            " <div style='clear: both;'> </div>" +

            // Info dialog
            " <div id='" + dstSettings.infoDialogId + "' class='dst_InfoDialog' ></div>" +

            // Memo dialog
            " <div id='" + dstSettings.memoDialogId + "' class='dst_MemoDialog'>" +
            "     <textarea cols='48' " + (dstSettings.allowMemoEdit ? '' : "readonly='readonly' disabled='disabled'") + " rows='5'></textarea>" +
            ' </div>' +

            // Context Menu
            " <ul id='dst_SlideContextMenu_" + dstSettings.uniqueId + "' class='cm_default jeegoocontext'" +
            "     data-bind='contextMenu: { options: { livequery: true, onHide: onMenuHide, onSelect: onMenuSelect, onShow: onMenuShow }, targetSelector: \".dst_slide-holder\" }'>" +
            '     <li>' + vm.contextMenuText[0] + '</li>' +
            '     <li>' + vm.contextMenuText[1] + '</li>' +
            '     <li>' + vm.contextMenuText[2] + '</li>' +
            ' </ul>' +

            " <script id='dst_CaseTemplate' type='text/html'>" +
            "     <div class='dst_accordion'  data-bind=\"spinner: isBusy, size: 'large', color : 'gray' \">";

  if (!dstSettings.displaySummaryTitle) {
    html += "<h3 style='visibility: hidden' />";
  } else {
    html += "<h3><a data-bind='text: currentCase().summaryTitleWithSlideCount'></a></h3>";
  }

  html += '   {{if activeCase().isPrimaryCase}}' +
            "             <div data-bind='template: { name: \"dst_SingleTrayDivTemplate\" }'> </div>" +
            '         {{else}}' +
            '             <div></div>' +
            '         {{/if}}' +

            '         {{if cases.length > 1}}' +
            '             <h3>' +
            "                 <a data-bind='text: priorCase().summaryTitleWithSlideCount'></a>" +
            '             </h3>' +
            '             {{if !activeCase().isPrimaryCase}}' +
            "                 <div data-bind='template: { name: \"dst_SingleTrayDivTemplate\" }'></div>" +
            '             {{else}}' +
            '                 <div></div>' +
            '             {{/if}}' +
            '         {{/if}}' +
            '     </div>' +

            "     <div style='clear: both;'></div>" +
            ' </script>' +

            " <script id='dst_SingleTrayDivTemplate' type='text/html'>" +
            // Related case dropdown
            '     {{if !activeCase().isPrimaryCase && cases.length > 2 }}' +
            '         <div>' +
            "             <select data-bind='options: activeCase().relatedCases(), optionsText: \"title\", optionsValue: \"recordId\", value: relatedCaseId'></select>" +
            '         </div>' +
            '     {{/if}}' +
            // Viewing link (View memos / View Slides
            "     <div data-bind='visible: " + (dstSettings.displayMemos ? 'true' : 'false') + "'>" +
            `         <a data-bind='click: activeCase().toggleViewMode, text: activeCase().viewMode() === "slides" ? "${$t('view-all-memos')}" : "${$t('view-slides')}"' href='#'></a>` +
            '     </div>' +
            // Display the slide tray
            "     <div data-bind='template: { name: \"dst_SingleSlideTrayEditorTemplate\", templateOptions: { clone: false, multiTray: false } }'>" +
            '     </div>' +
            // Display the tray selectors
            "     <div class='dst_tray-selector-container'>" +
            "         <span data-bind='template: { name: \"dst_TraySelectorTemplate\", afterRender: showSlideTrayEditor }'></span>" +
            '     </div>' +
            ' </script>' +

            " <script id='dst_MultiTrayDivTemplate' type='text/html'>" +
            '     {{each(iTray, tray) activeCase().editTraysVm.trays}}' +
            "         <div data-bind='template: { name: \"dst_MultiTrayTemplate\", " +
            "             templateOptions: { clone: true, multiTray: true, trayIndex: tray.index } }'>" +
            '         </div>' +
            '     {{/each}}' +
            ' </script>' +

            dstSingleTray(dstSettings) +

            // Multitray
            dstTrayHtml(dstSettings, true) +

            // Slide template
            "<script id='dst_SlideTemplate' type='text/html'>" +
            ' <li>' +
            "     <div class='dst_slide-holder'" +
            " data-bind='click: toggleSelectedStatus, css: {" +
            ' "dst_selected-slide-holder": isSelected,' +
            ' "dst_secondary-selected-slide-holder": isSecondarySelected,' +
            ' "dst_insert-indicator": isDraggedOver,' +
            ' "dst_dragged-indicator": isDragged,' +
            ' "dst_slide-placeholder": isBlank' +
            '},' +
            " readStatus: isRead'>" +
            '         {{if !isBlank}}' +
            "             <div class='dst_slide-holder-label'>" +
            "                 <img alt='' class='dst_label-thumbnail' src='${thumbnailLabelSrc}' />" +
            '             </div>' +
            "             <div class='dst_slide-holder-thumbnail'>" +
            "                 <img alt='' class='dst_image-thumbnail' src='${thumbnailImageSrc}' />" +
            '             </div>' +
            '         {{/if}}' +
            '     </div>' +

            //  we are moving the memo and slideinfo inside the new div.
            // + "     {{if isSelected}}"
            "     <div data-bind='css: {" +
            ' "dst_indicator-left": $item.column === 1,' +
            ' "dst_indicator-right": $item.column === 2,' +
            ' "dst_indicator-highlight": ' + dstSettings.displayBackgroundHighlight +
            " }'>" +

            '     {{if !$item.multiTray}}' +
            // Slide Info
            "         <span data-bind='unhidden: (" + (dstSettings.displaySlideInfo ? 'true' : 'false') + ") && isSecondarySelected() && !isBlank'>" +
            "             <a class='dst_info-indicator '" +
            "                 data-bind='click: showInfo, " +
            '                     css: {' +
            '                             "dst_indicator-icons-left": $item.column === 1, ' +
            '                             "dst_indicator-icons-right": $item.column === 2 ' +
            "                          }' " +
            "                 href='#'>" +
            "                 <i class='icon icon-fixed-width icon-info-sign' />" +
            '             </a>' +
            '         </span>' +
            //  Memos
            "         <span data-bind='unhidden: displayMemoIcon()'>" +
            "             <a class='dst_memo-indicator' " +
            "                 data-bind='attr: { title: memoContent }," +
            '                     click: showMemo,' +
            '                     css: {' +
            '                             "dst_memo-tooltip": memoContent() !== null ,' +
            '                             "dst_indicator-icons-left": $item.column === 1, ' +
            '                             "dst_indicator-icons-right": $item.column === 2 ' +
            "                          }' " +
            "                      href='#'>" +
            "                 <i class='icon icon-fixed-width icon-file-text' />" +
            '             </a>' +
            '         </span>' +
            '     {{/if}}' +

            '     </div>' +
            // + "     {{/if}}"
            ' </li>' +
            '</script>' +

            // Template for "View All Memos" page
            "<script id='dst_MemosTemplate' type='text/html'>" +
            ' <li>' +
            "     <div class='dst_memo-holder dst_memo-holder-col-${$item.column}'" +
            " data-bind='click: toggleSelectedStatus, css: {" +
            ' "dst_selected-memo-holder": isSelected(),' +
            ' "dst_secondary-selected-slide-holder": isSecondarySelected()' +
            '},' +
            " text: trimmedMemo'>" +
            '     </div>' +
            ' </li>' +
            '</script>' +

            // Groups
            "<script id='dst_GroupsTemplate' type='text/html'>" +
            " <li class='dst_group-line' data-bind='css: {" +
            ' "dst_left-top": group.isStart() && $item.column === 1,' +
            ' "dst_left-bottom": group.isEnd() && $item.column === 1,' +
            ' "dst_left-middle": group.isMiddle() && $item.column === 1,' +
            ' "dst_left-single": group.isSingle() && $item.column === 1,' +
            ' "dst_right-top": group.isStart() && $item.column === 2,' +
            ' "dst_right-bottom": group.isEnd() && $item.column === 2,' +
            ' "dst_right-middle": group.isMiddle() && $item.column === 2,' +
            ' "dst_right-single": group.isSingle() && $item.column === 2' +
            " }'>";

  if (dstSettings.displayGroupings && dstSettings.displayGroupTitles) { // group titles now 'off' by default, for backward campatibility with PeerReview
    html += ' {{if group.dispTitle()}}' +
                "     <span class='grouptitle'>${group.title}</span>" +
                ' {{/if}}';
  }

  if (dstSettings.displayMultiSlide && !dstSettings.displayPosNegControl) {
    var itemIdTemplate = '"checkbox_"  + ($item.multiTray ? $item.trayIndex : "x") + "_" + $item.column + "_" + $index()';

    html += "   <span class='dst_multiSlide' data-bind='visible: $parent.isMultiSlideEnabled() && !isBlank, " +
                "css: { \"dst_multiSlide-right\": $item.column === 2 }' >" +
                "<input type='checkbox' class='' data-bind='attr: { \"id\": " + itemIdTemplate + " }, checked: isMultiSlideSelected, disable: isSelected() || (($parent.maxPinned()) && !(isMultiSlideSelected())) '  />  " +
                "<label data-bind='attr: { \"for\": " + itemIdTemplate + " }' /> " +
                ' </span>';
  }

  html += '   </li>' +
            '</script>' +

            // Labels
            "<script id='dst_LabelTemplate' type='text/html'>" +
            ' <li>${$data}</li>' +
            '</script>' +

            // Slide Background
            " <script id='dst_SlideBackgroundTemplate' type='text/html'>" +
            '     <li></li>' +
            ' </script>' +

            // Tray indicies and "Edit Trays" links
            " <script id='dst_TraySelectorTemplate' type='text/html'>" +
            '     {{if displayTray() !== undefined}}' +
            //          Double Left Chevron
            '         {{if displayTray().index === 0}}' +
            ' ' + String.fromCharCode(0x00AB) + ' ' +
            '         {{else}}' +
            "             <a class='dst_tray-selector' data-bind='click: function () { displayTray().changeTray(displayTray().index - 1); }' href='#'>" +
            String.fromCharCode(0x00AB) + '</a>' +
            '         {{/if}}' +

            //          Trays
            '         {{each(i, tray) activeCase().trays}}' +
            '             {{if i === displayTray().index}}' +
            "                 <span class='dst_tray-selector dst_current-tray'>${i + 1}</span>" +
            '             {{else}}' +
            "                 <a class='dst_tray-selector' data-bind='click: function () { displayTray().changeTray(i); }, css: { \"dst_unread-tray\": !isTrayRead() }' href='#'>${i + 1}</a>" +
            '             {{/if}}' +
            '         {{/each}}' +

            //          Double Right Chevron
            '         {{if displayTray().index === activeCase().trays().length - 1}}' +
            ' ' + String.fromCharCode(0x00BB) + ' ' +
            '         {{else}}' +
            "             <a class='dst_tray-selector' data-bind='click: function () { displayTray().changeTray(displayTray().index + 1); }' href='#'>" +
            String.fromCharCode(0x00BB) + '</a>' +
            '         {{/if}}' +

            //          Edit Trays Link
            '         {{if activeCase().trays().length > 1}}' +
            (dstSettings.enableMultiTray ? "<a class='dst_multiTrayLink' href='#dst_EditTrays'>" + $t('edit-trays') + '</a>' : '') +
            '         {{/if}}' +

            '     {{/if}}' +
            ' </script>';

  return html;
};

var dstSingleTray = function (dstSettings) {
  var html = "<script id='dst_SingleSlideTrayEditorTemplate' type='text/html'>" +
            " <div class='dst_tray'>" +
            "     <div class='dst_tray-background'>";

  if (dstSettings.displayPosNegControl && !dstSettings.displayMultiSlide) {
    html += "<div class='posNegSlideContainer' >" +
                "<div class='posNegSlide positive' >" +
                "<ul class='dst_slide-col' data-bind='multiSortableList: { listItems: posNegSlides }, " +
                "template: {  name: function () { return \"dst_SlideTemplate\" }, foreach: $.grep(posNegSlides(), function(item) { return item.sampleType == \"positive\" }) }'></ul>" +
                "<ul class='dst_slide-col dst_slide-col-background' >" +
                " <li><i class='icon-li icon-plus-sign icon-fixed-width icon-large'></i>" +
                'Positive' +
                ' </li>' +
                '</ul>' +
                '</div>' +
                "<div class='posNegSlide negative' >" +
                "<ul class='dst_slide-col' data-bind='multiSortableList: { listItems: posNegSlides }, " +
                "template: { name: function () { return \"dst_SlideTemplate\" }, foreach: $.grep(posNegSlides(), function(item) { return item.sampleType == \"negative\" }) }'></ul>" +
                "<ul class='dst_slide-col dst_slide-col-background' >" +
                " <li><i class='icon-li icon-minus-sign icon-fixed-width icon-large'></i>" +
                'Negative' +
                ' </li>' +
                '</ul>' +
                '</div>' +
                "<div style='clear: both;'></div>" +
                '</div>';
  }

  if (dstSettings.displayGroupings) {
    html += "               <ul class='dst_tray-col dst_group-col' data-bind='template: { name: \"dst_GroupsTemplate\", " +
                '             foreach: displayTray().slides.slice(0, 10), templateOptions: { column: 1, multiTray: false } }, ' +
                '                 visible: ' + (dstSettings.displayGroupings ? 'true' : 'false') + "'>" +
                '         </ul>';
  } else {
    html += "                     <ul class='dst_tray-col dst_group-col'><li></li></ul>";
  }

  html += "                       <ul class='dst_tray-col dst_slide-col dst_slide-col-1' data-bind='" +
            // Drag & Drop (jQuery Sortable), first column
            '             multiSortableList: { listItems: $item.clone ? ( activeCase().editTraysVm.trays().length ? activeCase().editTraysVm.trays()[$item.trayIndex].slides.slice(0, 10) : [] ) : displayTray().slides.slice(0, 10), clone: $item.clone, multiTray: $item.multiTray, dstSettings: { slidesPerTray: 20 } }, ' +
            "             template: { afterRender: addSlideBehaviors, name: function () { return $item.clone || activeCase().viewMode() === \"slides\" ? \"dst_SlideTemplate\" : \"dst_MemosTemplate\" }, foreach: $item.clone ? ( activeCase().editTraysVm.trays().length ? activeCase().editTraysVm.trays()[$item.trayIndex].slides.slice(0, 10) : [] ) : displayTray().slides.slice(0, 10), templateOptions: { column: 1 } }'>" +
            '             </ul>' +
            "             <ul class='dst_tray-col dst_slide-col-background dst_slide-col-1-background ' data-bind='template: { name: \"dst_SlideBackgroundTemplate\", foreach: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }'>" +
            '             </ul>' +
            "             <ul class='dst_tray-col dst_label-col dst_label-col-1' data-bind='template: { name: \"dst_LabelTemplate\", foreach: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }'>" +
            '             </ul>' +
            "             <ul class='dst_tray-col dst_label-col dst_label-col-2' data-bind='template: { name: \"dst_LabelTemplate\", foreach: [11, 12, 13, 14, 15, 16, 17, 18, 19, 20] }'>" +
            '             </ul>' +
            "             <ul class='dst_tray-col dst_slide-col dst_slide-col-2' data-bind='" +
            // Drag & Drop (jQuery Sortable), second column
            '             multiSortableList: { listItems: $item.clone ? ( activeCase().editTraysVm.trays()[$item.trayIndex] ? activeCase().editTraysVm.trays()[$item.trayIndex].slides.slice(10) : displayTray().slides.slice(10) ) : displayTray().slides.slice(10), clone: $item.clone, multiTray: $item.multiTray, dstSettings: { slidesPerTray: 20 } }, ' +
            "             template: { afterRender: addSlideBehaviors, name: function () { return $item.clone || activeCase().viewMode() === \"slides\" ? \"dst_SlideTemplate\" : \"dst_MemosTemplate\" }, foreach: $item.clone ? ( activeCase().editTraysVm.trays()[$item.trayIndex] ? activeCase().editTraysVm.trays()[$item.trayIndex].slides.slice(10) : displayTray().slides.slice(10) ) : displayTray().slides.slice(10), templateOptions: { column: 2 } }'>" +
            '             </ul>' +
            "             <ul class='dst_tray-col dst_slide-col-background dst_slide-col-2-background ' data-bind='template: { name: \"dst_SlideBackgroundTemplate\", foreach: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }'>" +
            '             </ul>';

  if (dstSettings.displayGroupings) {
    html += "           <ul class='dst_tray-col dst_group-col' data-bind='template: { name: \"dst_GroupsTemplate\", " +
                '             foreach: displayTray().slides.slice(10), templateOptions: { column: 2, multiTray: false } }, ' +
                '                     visible: ' + (dstSettings.displayGroupings ? 'true' : 'false') + "'>" +
                '         </ul>';
  } else {
    html += "                     <ul class='dst_tray-col dst_group-col'><li></li></ul>";
  }

  html += "       <div class='slide-nav'>" +
            "             <button class='prevSlideLink slide-nav-button-inactive' title='" + $t('previous-slide-tooltip') + "' data-bind='click: movePrevSlide'>" + String.fromCharCode(0x025C0) + '&emsp;' + $t('previous-slide') + '</button>' +
            "             <button class='nextSlideLink slide-nav-button-inactive' title='" + $t('next-slide-tooltip') + "' data-bind='click: moveNextSlide'>" + $t('next-slide') + '&emsp;' + String.fromCharCode(0x025B6) + '</button>' +
            "             <div style='clear: both;'></div>" +
            '         </div>' +
            '     </div>' +
            ' </div>' +
            ' </script>';

  return html;
};

var dstTrayHtml = function (dstSettings, isMultiTray) {
  // The following code is being transformed into a generic tray producer.  I've not yet moved the single tray to this factory.
  var name;
  var thisTray;
  var isSingleTray;
  var componentTemplate;
  if (isMultiTray) {
    isSingleTray = false;
    isMultiTray = 'true';
    name = 'dst_MultiTrayTemplate';
    thisTray = 'activeCase().editTraysVm.trays()[$item.trayIndex]';
    componentTemplate = '"dst_SlideTemplate"';
  } else {
    isSingleTray = true;
    isMultiTray = 'false';
    name = 'dst_SingleTrayTemplate';
    thisTray = 'displayTray()';
    componentTemplate = 'activeCase().viewMode() === "slides" ? "dst_SlideTemplate" : "dst_MemosTemplate"';
  }

  var html =
            "<script id='" + name + "' type='text/html'>" +
            " <div class='dst_tray'>" +
            "     <div class='dst_tray-background'>" +

            // Grouping (left side)
            "         <ul class='dst_tray-col dst_group-col'" +
            "             data-bind='template: { name: \"dst_GroupsTemplate\", " +
            '                 foreach: ' + thisTray + '.slides.slice(0, 10), ' +
            '                 templateOptions: { column: 1, multiTray: ' + isMultiTray + ', trayIndex: $item.trayIndex } }, ' +
            '             visible: ' + (dstSettings.displayGroupings ? 'true' : 'false') +
            "         '>" +
            '         </ul>' +

            // Drag & Drop (jQuery Sortable), first column
            "         <ul class='dst_tray-col dst_slide-col dst_slide-col-1'" +
            "             data-bind='multiSortableList:" +
            '             {' +
            '                 listItems: ' + thisTray + '.slides.slice(0, 10),' +
            '                 clone: $item.clone, multiTray: $item.multiTray, dstSettings: { slidesPerTray: 20 }' +
            '             },' +
            '             template:' +
            '             {' +
            '                 afterRender: addSlideBehaviors,' +
            '                 name: function ()' +
            '                 {' +
            '                     return ' + componentTemplate +
            '                 },' +
            '                 foreach: ' + thisTray + '.slides.slice(0, 10),' +
            '                 templateOptions: { column: 1 }' +
            '             }' +
            "             '>" +
            '         </ul>' +
            "         <ul class='dst_tray-col dst_slide-col-background dst_slide-col-1-background '" +
            "             data-bind='template: { name: \"dst_SlideBackgroundTemplate\", foreach: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }'>" +
            '         </ul>' +
            "         <ul class='dst_tray-col dst_label-col dst_label-col-1'" +
            "             data-bind='template: { name: \"dst_LabelTemplate\", foreach: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }'>" +
            '         </ul>' +
            "         <ul class='dst_tray-col dst_label-col dst_label-col-2'" +
            "             data-bind='template: { name: \"dst_LabelTemplate\", foreach: [11, 12, 13, 14, 15, 16, 17, 18, 19, 20] }'>" +
            '         </ul>' +

            // Drag & Drop (jQuery Sortable), second column
            "         <ul class='dst_tray-col dst_slide-col dst_slide-col-2'" +
            "             data-bind='multiSortableList:" +
            '             {' +
            '                 listItems: ' + thisTray + '.slides.slice(10),' +
            '                 clone: $item.clone, multiTray: $item.multiTray, dstSettings: { slidesPerTray: 20 }' +
            '             },' +
            '             template:' +
            '             {' +
            '                 afterRender: addSlideBehaviors,' +
            '                 name: function ()' +
            '                 {' +
            '                     return ' + componentTemplate +
            '                 },' +
            '                 foreach: ' + thisTray + '.slides.slice(10),' +
            '                 templateOptions: { column: 2 }' +
            '             }' +
            "             '>" +
            '         </ul>' +

            "         <ul class='dst_tray-col dst_slide-col-background dst_slide-col-2-background '" +
            "             data-bind='template: { name: \"dst_SlideBackgroundTemplate\", foreach: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }'>" +
            '         </ul>' +

            // Grouping (right side)
            "         <ul class='dst_tray-col dst_group-col'" +
            "             data-bind='template: { name: \"dst_GroupsTemplate\", " +
            '                 foreach: ' + thisTray + '.slides.slice(10), ' +
            '                 templateOptions: { column: 2, multiTray: ' + isMultiTray + ', trayIndex: $item.trayIndex } }, ' +
            '             visible: ' + (dstSettings.displayGroupings ? 'true' : 'false') +
            "         '>" +
            '         </ul>';

  if (isSingleTray) {
    html +=
                +"      <div class='slide-nav'>" +
                "         <button class='prevSlideLink slide-nav-button-inactive' title='" + $t('previous-slide-tooltip') + "' data-bind='click: movePrevSlide'>" + String.fromCharCode(0x025C0) + '&emsp;' + $t('previous-slide') + '</button>' +
                "         <button class='nextSlideLink slide-nav-button-inactive' title='" + $t('next-slide-tooltip') + "' data-bind='click: moveNextSlide'>" + $t('next-slide') + '&emsp;' + String.fromCharCode(0x025B6) + '</button>' +
                '     </div>';
  }

  html +=
            '       </div>' +
            ' </div>' +
            '</script>';

  return html;
};

var dstEditTray = function (settings) {
  if (!$('#dst_EditTrays').length) {
    var multiTrayWidth = settings.multiTrayWidth + 25;
    var multiTrayHeight = settings.multiTrayHeight + 50;
    var html =
                "<div style='display: none; overflow: overlay'>" +
                "     <div id='dst_EditTrays' style='width:" + multiTrayWidth + 'px; height:' + multiTrayHeight + "px;'>" +
                "         <div class='dst_inter-tray' data-bind='template: { name: \"dst_multiTrayTemplate\" }'></div>" +
                '     </div>' +
                '</div>';
    $('body').append(html);
  }

  if (!$('#dst_multiTrayTemplate').length) {
    var translatePrev = $t('prev');
    var translateNext = $t('next');
    var translateTray = $t('tray');
    var templateHtml =
                  "<script id='dst_multiTrayTemplate' type='text/html'>" +
                " <div class='dst_edit-tray-nav'>" +
                '     {{if activeCase().editTraysVm.enableScrollBackward}}' +
                `         <a class='dst_prev-tray' data-bind='click: function () { activeCase().editTraysVm.scroll(-1); }' href='#'>${translatePrev}</a>` +
                '     {{else}}' +
                `        ${translatePrev} ` +
                '     {{/if}}' +
                `     <br><span data-bind='text:  "${translateTray} " + (activeCase().editTraysVm.startTrayIndex()+1) '> </span>` +
                ' </div>' +
                " <div data-bind='template: { name: \"dst_MultiTrayDivTemplate\", templateOptions: { multiTray: true } }' class='dst-multi-tray-container'>" +
                ' </div>' +
                " <div class='dst_edit-tray-nav' >" +
                '     {{if activeCase().editTraysVm.enableScrollForward}}' +
                `         <a class='dst_next-tray' data-bind='click: function () { activeCase().editTraysVm.scroll(1); }' href='#'>${translateNext}</a>` +
                '     {{else}}' +
                `        ${translateNext} ` +
                '     {{/if}}' +
                `     <br><span data-bind='text: "${translateTray} " + activeCase().editTraysVm.endTrayIndex() '> </span>` +
                ' </div>' +
                '</script>';
    $('body').append(templateHtml);
  }
};



// WEBPACK FOOTER //
// ./src/slide-tray/jquery.dst.js